import wait from "../utilities/wait";

let hasAdBlocker = null;

const verifyAdBlockerActive = async () => {
    const adDiv = document.createElement('div');
    adDiv.innerHTML = '&nbsp;';
    adDiv.className = "ads ad adsbox doubleclick ad-placement carbon-ads";
    document.body.appendChild(adDiv);
    await wait(50);
    const adBlockerActive = adDiv.offsetHeight === 0;
    adDiv.remove();
    return adBlockerActive;
}

// Evaluate once if Ads/Adobe is blocked and cache response
export const checkAdBlockerActive = async () => {
    if (hasAdBlocker === null) {
        hasAdBlocker = await verifyAdBlockerActive();
    }
    return hasAdBlocker;
}

